const cards = [
  {
    tag: '热播剧集',
    title: '悬疑剧场：烧脑高分神作合集',
    desc: '精选国内外高分悬疑剧，反转不断，一集入坑停不下来。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20detective%20noir%20scene%20with%20warm%20moody%20lighting%2C%20shadowy%20office%20with%20case%20files%20on%20desk%2C%20magnifying%20glass%20and%20vintage%20lamp%2C%20rich%20amber%20and%20deep%20brown%20tones%2C%20cinematic%20composition%2C%20editorial%20photography%20style%2C%20simple%20dark%20background%2C%20film%20noir%20aesthetic&width=600&height=400&seq=tangxin-card-01&orientation=landscape',
  },
  {
    tag: '电影大全',
    title: '国产口碑佳作：豆瓣8分以上精选',
    desc: '甄选近年国产高分电影，剧情饱满演技在线，值得反复观看。',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20nostalgic%20Chinese%20family%20dinner%20scene%20with%20soft%20natural%20lighting%20from%20window%2C%20steaming%20dishes%20on%20wooden%20table%2C%20gentle%20warm%20atmosphere%2C%20traditional%20Chinese%20home%20interior%2C%20emotional%20storytelling%20mood%2C%20cinematic%20photography%20with%20shallow%20depth%20of%20field%2C%20simple%20background&width=600&height=400&seq=tangxin-card-02&orientation=landscape',
  },
  {
    tag: '综艺娱乐',
    title: '热门综艺一网打尽 · 欢笑不间断',
    desc: '全网最热综艺合集，搞笑、音乐、旅行、美食，总有一款你爱看。',
    img: 'https://readdy.ai/api/search-image?query=A%20bright%20colorful%20variety%20show%20stage%20with%20warm%20spotlights%20and%20cheerful%20atmosphere%2C%20vibrant%20studio%20set%20with%20colorful%20decorations%2C%20energetic%20entertainment%20vibe%2C%20soft%20warm%20lighting%20on%20stage%2C%20professional%20broadcast%20production%20look%2C%20simple%20studio%20background&width=600&height=400&seq=tangxin-card-03&orientation=landscape',
  },
  {
    tag: '动漫频道',
    title: '人气新番+经典重温 · 二次元盛宴',
    desc: '追最新番剧，重温童年经典。热血、治愈、搞笑全类型覆盖。',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20anime%20style%20illustration%20with%20warm%20sunset%20lighting%2C%20charming%20character%20silhouettes%20in%20a%20dreamy%20landscape%2C%20soft%20golden%20hour%20glow%2C%20whimsical%20and%20nostalgic%20atmosphere%2C%20gentle%20color%20gradient%20sky%2C%20simple%20natural%20background%2C%20artistic%20composition&width=600&height=400&seq=tangxin-card-04&orientation=landscape',
  },
  {
    tag: '纪录片库',
    title: '顶级纪录片 · 打开世界新视角',
    desc: 'BBC、NHK、央视精品纪录片，自然、历史、科技全方位探索。',
    img: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20nature%20documentary%20scene%20with%20golden%20sunlight%20over%20misty%20mountains%2C%20wildlife%20silhouette%20in%20distance%2C%20rich%20warm%20earth%20tones%2C%20epic%20landscape%20photography%2C%20soft%20atmospheric%20haze%2C%20cinematic%20wide%20shot%2C%20simple%20natural%20background&width=600&height=400&seq=tangxin-card-05&orientation=landscape',
  },
  {
    tag: '韩剧专区',
    title: '高分韩剧合集 · 浪漫与悬疑齐飞',
    desc: '从甜宠恋爱到烧脑悬疑，韩剧高分作品一网打尽，追到停不下来。',
    img: 'https://readdy.ai/api/search-image?query=A%20romantic%20cozy%20coffee%20shop%20scene%20with%20warm%20interior%20lighting%2C%20two%20coffee%20cups%20on%20wooden%20table%20by%20rainy%20window%2C%20soft%20bokeh%20lights%20in%20background%2C%20intimate%20warm%20atmosphere%2C%20Korean%20drama%20aesthetic%2C%20cinematic%20composition%2C%20simple%20cafe%20background&width=600&height=400&seq=tangxin-card-06&orientation=landscape',
  },
  {
    tag: '美剧精选',
    title: '高分美剧一站看 · 全程高能无尿点',
    desc: 'IMDb与豆瓣双高分美剧，剧情紧凑制作精良，周末一口气刷完一整季。',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20urban%20cityscape%20at%20twilight%20with%20warm%20street%20lights%20glowing%2C%20modern%20skyscrapers%20skyline%2C%20reflective%20wet%20pavement%20after%20rain%2C%20cinematic%20moody%20atmosphere%2C%20rich%20amber%20and%20deep%20blue%20tonal%20contrast%2C%20professional%20photography%2C%20simple%20urban%20background&width=600&height=400&seq=tangxin-card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-4">
              精选推荐
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
          </div>
          <a
            href="#index"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="whitespace-nowrap hidden sm:inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 mt-4 sm:mt-0 cursor-pointer"
          >
            查看全部专题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cards.slice(0, 3).map((card) => (
            <div
              key={card.title}
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mt-5 md:mt-6">
          {cards.slice(3).map((card) => (
            <div
              key={card.title}
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}